const accordionBlock = () => {
	const accordionItems = document.querySelectorAll('.wp-block-pushengage-theme-accordion-item');

	if (!accordionItems.length) {
		return;
	}

	const hasHash = location.hash.slice(1);
	accordionItems.forEach((item) => {
		const itemSummary = item.querySelector('.wp-block-am-accordion-item__summary');
		const itemContent = item.querySelector('.wp-block-am-accordion-item__content');

		if (hasHash && hasHash === item.id) {
			item.classList.add('is-open');
			item.classList.add('opened-by-link');

			setTimeout(() => {
				window.scrollBy(0, -100);
			}, 50);
		}

		itemSummary.addEventListener('click', () => {
			itemContent.style.setProperty('--content-height', `${itemContent.scrollHeight}px`);
			item.classList.toggle('is-open');
			item.classList.remove('opened-by-link');
		});
	});
};

export default accordionBlock;